var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBa1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 346.398,
    height: 188.867,
    viewBox: "0 0 346.398 188.867",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4391.591 -1175.745)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6e7e9d",
    d: "M4650.966 1306.166h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m4.647-26.108h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m-141.598-26.108h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m4.647-26.108h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m-30.576 6.527h30.576m53.876-76.718h21.923m-52.326 0h20.862m-2.459 13.656h33.923m-52.326 0h8.862m-214.184-63.274h9.917v9.917h-9.917zm-17.984 0h9.917v9.917h-9.917zm-17.983 0h9.917v9.917h-9.917zm9.917 4.959h8.066m9.917 0h8.066m75.8-4.959h9.917v9.917h-9.917zm-17.983 0h9.917v9.917h-9.917zm-17.984 0h9.917v9.917h-9.917zm9.917 4.959h8.066m9.918 0h8.066m-75.799 31.149h9.917v9.917h-9.917zm-17.984 0h9.917v9.917h-9.917zm-17.983 0h9.917v9.917h-9.917zm9.917 4.959h8.066m9.917 0h8.066m75.8-4.959h9.917v9.917h-9.917zm-17.983 0h9.917v9.917h-9.917zm-17.984 0h9.917v9.917h-9.917zm9.917 4.959h8.066m9.918 0h8.066m-75.799 31.149h9.917v9.917h-9.917zm-17.984 0h9.917v9.917h-9.917zm-17.983 0h9.917v9.917h-9.917zm9.917 4.958h8.066m9.917 0h8.066m75.8-4.958h9.917v9.917h-9.917zm-17.983 0h9.917v9.917h-9.917zm-17.984 0h9.917v9.917h-9.917zm9.917 4.958h8.066m9.918 0h8.066m-75.799 30.456h9.917v9.917h-9.917zm-17.984 0h9.917v9.917h-9.917zm-17.983 0h9.917v9.917h-9.917zm9.917 4.959h8.066m9.917 0h8.066m75.8-4.959h9.917v9.917h-9.917zm-17.983 0h9.917v9.917h-9.917zm-17.984 0h9.917v9.917h-9.917zm9.917 4.959h8.066m9.918 0h8.066"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4392.091 1176.245h345.398v187.867h-345.398z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4727.489 1186.245v157.626h-325.397v-157.626z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4.811,
    cy: 4.811,
    r: 4.811,
    transform: "translate(4559.98 1349.13)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4564.791 1186.245v157.626m-151.599-146.028h65.799v26.108h-65.799zm75.8 0h65.799v26.108h-65.799zm-75.8 36.108h65.799v26.108h-65.799zm75.8 0h65.799v26.108h-65.799zm-75.8 36.107h65.799v26.108h-65.799zm75.8 0h65.799v26.108h-65.799zm-75.8 36.108h65.799v26.108h-65.799zm75.8 0h65.799v26.108h-65.799z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 37.9,
    cy: 37.9,
    r: 37.9,
    transform: "translate(4575.167 1204.359)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.203,
    cy: 12.203,
    r: 12.203,
    transform: "translate(4600.864 1230.056)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4478.992 1210.897h10m32.899 13.054v10m-32.899 13.054h-10m-32.9 13.053v10m32.9 13.054h10m32.899 13.054v10m-32.899 13.054h-10m85.799-23.054h162.699m-102.221-53.907h25.697m-37.9-12.203v-25.697m51.373 37.9h52.325"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.376,
    cy: 2.376,
    r: 2.376,
    transform: "translate(4667.279 1227.68)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.376,
    cy: 2.376,
    r: 2.376,
    transform: "translate(4680.89 1214.831)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.376,
    cy: 2.376,
    r: 2.376,
    transform: "translate(4694.5 1222.927)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.376,
    cy: 2.376,
    r: 2.376,
    transform: "translate(4708.11 1213.701)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4698.843 1223.97l9.677-6.56m-23.219 1.008l9.54 5.675m-23.458 4.333l10.159-9.59m-11.886 13.596v9.826m13.61-22.674v22.675m13.61-14.579v14.579m13.61-23.806v23.805"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.54,
    height: 6.349,
    rx: 3.175,
    transform: "translate(4685.301 1252.381)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9.54,
    height: 6.349,
    rx: 3.175,
    transform: "translate(4673.301 1266.038)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4569.601 1353.941h157.888m-167.509 0h-157.888"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa1);
export default __webpack_public_path__ + "static/media/ba1.f8c7fcb626c36bd83eda4f6e280ff149.svg";
export { ForwardRef as ReactComponent };